import { createContext, useMemo } from 'react';
import { invert } from 'lodash';

export const ModuleContext = createContext({
    toGWTransformers: {},
    entities: {},
    entitiesToPath: {},
    pathToEntity: {},
});
const DEFAULT_TO_GW_TRANSFORMERS = {};
const DEFAULT_ENTITIES = {};
const DEFAULT_ENTITIES_TO_PATH = {};
export const ModuleProvider = ({
    children,
    toGWTransformers = DEFAULT_TO_GW_TRANSFORMERS,
    entities = DEFAULT_ENTITIES,
    entitiesToPath = DEFAULT_ENTITIES_TO_PATH,
}) => {
    const value = useMemo(() => {
        const pathToEntity = invert(entitiesToPath);
        return { toGWTransformers, entities, entitiesToPath, pathToEntity };
    }, [toGWTransformers, entities, entitiesToPath]);

    return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
};
